module.exports = __webpack_public_path__ + "img/angle.cf5aab4f.svg";